/* eslint-disable */
import { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import moment from 'moment';
import { Download, Visibility } from '@mui/icons-material';
import { Button, Chip, Tooltip } from '@mui/material';
import { connect } from 'react-redux';
import ImagesFinder from '../../Components/ImagesFinder/ImagesFinder';
import { ListTable } from '../../Components/ListTable';
import styles from './UtilitiesPage.module.scss';
import { urls } from '../../Constants';
import financialTransactionsServices from '../../Services/Analytics Services/financial-transactions.services';
import inventoryAnalyticsServices from '../../Services/Analytics Services/inventory-analytics.services';
import { notificationServices } from '../../Services';
import { formActions, modalActions } from '../../Actions';
import { POItemsModal } from '../../Components/Modals/POItemsModal';
import { BackdropLoader } from '../../Components/Loaders';
import { filtersInfoChip, getActionColumn, getFileName, handleExcelDownload } from '../../Helpers';
import useSearchFilters from '../../Helpers/useSearchFilters';
import userRolesAndPermissions from '@/Services/userRolesAndPermissions.services';
import { useAuth } from '@/Components/Auth/Login/auth';
import authActions from '@/Actions/auth.actions';
import { Filter, RefreshCcw } from 'lucide-react';
import drawerActions from '@/Actions/drawer.actions';
import GlobalSearch from '@/Components/globalSearch/search';

const statusList = [
	{
		id: 'CANCELLED',
		title: 'CANCELLED',
	},
	{
		id: 'PAID',
		title: 'PAID',
	},
	{
		id: 'UNPAID',
		title: 'UNPAID',
	},
	{
		id: 'PARTIALLY_PAID',
		title: 'PARTIALLY PAID',
	},
	{
		id: 'APPROVAL_PENDING_MANAGER',
		title: 'APPROVAL PENDING MANAGER',
	},
	{
		id: 'APPROVAL_PENDING_FINANCE',
		title: 'APPROVAL PENDING FINANCE',
	},
];

const timeTypeArr = [
	{
		label: 'Created At',
		value: 'createdAt',
	},
	{
		label: 'Bill Date',
		value: 'transactionDate',
		disabledFutureDate: true,
	},
	{
		label: 'Due Date',
		value: 'dueDate',
	},
];

const TABLE_COLUMNS = [
	{
		title: 'Id',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Vendor',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Store',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Client Transaction ID',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Status',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Payment By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Created By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Created At',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Bill Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Due Date',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Category',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Period From',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Period To',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'L1 Action By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'L2 Action By',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Amount Before tax',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Tax slab',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Tax amount',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Total Amount',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Reference doc',
		config: {
			type: 'DATA',
		},
	},
	{
		title: 'Description',
		config: {
			type: 'DATA',
		},
	},
];

const BASE_COLUMN = [
	{
		title: 'View',
		config: {
			type: 'VIEW',
		},
	},
];

const ADDITIONAL_COLUMNS = [
	{
		title: 'Actions',
		config: {
			type: 'DATA',
		},
	},
];
const COLMAP = {
	Id : 'id',
	Vendor: 'vendorName',
	Store: 'storeName',
	'Client Transaction ID': 'clientTransactionId',
	Status: 'id',
	'Bill Date': 'transactionDate',
	'Due Date': 'dueDate',
	'Created By': 'initiatedByUserDisplayName',
	'Created At': 'createdAt',
	Category: 'category',
	'Period From': 'extraData',
	'Period To': 'extraData',
	'L1 Action By': 'l1ActionByUserDisplayName',
	'L2 Action By': 'l2ActionByUserDisplayName',
	'Tax slab': 'id',
	'Tax amount': 'id',
	'Amount Before tax': 'id',
	'Total Amount': 'id',
	'Reference doc': 'uploadedDoc',
	'Description': 'id',
};

const searchQueries = [
	{
		id: 'transactionId',
		type: 'billId',
		generateTitle: (exlusiveKey) => {
			return `Id: ${exlusiveKey}`;
		},
		removable: true,
		exclusiveKey: 'clientTransactionId',
		dependentKey: '',
	},
];

const UtilitiesPage = (props) => {
	const {
		togglePOItemsModal,
		toggleAlert,
		stores,
		vendorsList,
		fetchAllVendors,
		fetchStoresList,
		toggleFiltersDrawer,
	} = props;
	const history = useHistory();
	const { userConfig = {}} = useAuth();
	const directLevel = userConfig?.userDetails?.level;
	const [utilitiesList, setUtilitiesList] = useState([]);
	const [update, setUpdate] = useState(-1);
	const [isLoading, setIsLoading] = useState(false);
	const [filters, setFilters] = useState({});
	const [search, setSearch] = useState({});
	const [isRefresh, setIsRefresh] = useState(false);
	const { level } = userConfig?.userDetails || {};
	const { userRolesDict = {} } = userConfig || {};
	const isInternal = Object?.values?.(userRolesDict ?? {}).includes('INTERNAL') || Object?.values?.(userRolesDict ?? {}).includes('CXO Office');
	const levels = [3, 4];


	const { searchFilters } = useSearchFilters({
		searchQueries,
		callBackFn: () => {
			setUpdate((prev) => {
				return prev + 1;
			});
		},
	});

	useEffect(() => {
		fetchAllVendors({
			entity: 'ALL_VENDORS',
			req: {
				params: {
					id: '',
				},
			},
			method: 'LIST',
		});
		fetchStoresList({
			entity: 'STORES',
			req: {
				params: {
					id: '',
					type: '',
				},
			},
			method: 'LIST',
		});
	}, []);

	const storeIdMap = useMemo(() => {
		const map = {};
		stores?.forEach((ele) => {
			map[ele?.id] = ele;
		});
		return map;
	}, [stores]);

	const vendorIdMap = useMemo(() => {
		const map = {};
		vendorsList?.forEach((ele) => {
			map[ele?.id] = ele;
		});
		return map;
	}, [vendorsList]);

	const handleStatus = async (data, rejectionReason, type) => {
		let status = '';
		if (data?.transactionStatus === 'APPROVAL_PENDING_MANAGER') {
			status = 'APPROVAL_PENDING_FINANCE';
		}
		if (data?.transactionStatus === 'APPROVAL_PENDING_FINANCE') {
			if (data?.extraData?.isPaid) {
				status = 'PAID';
			} else {
				status = 'UNPAID';
			}
		}
		if (type === 'rejection') {
			status = 'REJECTED';
		}
		if (type === 'cancelation') {
			status = 'CANCELLED';
		}
		try {
			const responseData =
				await inventoryAnalyticsServices.updateInventoryTransaction({
					params: {
						transactionId: data?.id,
					},
					data: {
						status,
						type: 'BILL',
						nextFlowLink: `${window?.location?.origin}${urls.EXTENSION}${urls.UTILITIES_PAGE}?clientUtilityId=${data?.clientTransactionId}`,
						...(type === 'rejection' && {
							rejectionReason,
						}),
					},
				});
			if (responseData?.statusCode === 200) {
				setUpdate((prev) => {
					return prev + 1;
				});
				notificationServices?.generateNotification({
					type: 'success',
					message: responseData?.message,
				});
				togglePOItemsModal(false, {});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const getTaxFromStr = (tt) => {
		let num = 0;
		let taxStr = tt;
		if (!taxStr) return num;
		if (taxStr?.includes?.('%')) {
			taxStr = taxStr?.replace('%', '');
			if (!Number.isNaN(taxStr)) {
				num = Number(taxStr);
			}
		}
		return num;
	};

	const handleEditClick = (item) => {
		const redirectUrl = `${urls.EXTENSION}${urls.UTILITIES_PAGE}/add?id=${item?.id}&edit=true`;
		window.open(redirectUrl, '_blank');
	};

	const specialItems = {
		'Tax slab': (id) => {
			const item = utilitiesList?.find((ele) => {
				return ele?.id === id;
			});
			const taxStr = item?.extraData?.taxSlab;
			if (!taxStr) {
				return '-';
			}
			return taxStr;
		},
		'Tax amount': (id, showRs = true) => {
			const item = utilitiesList?.find((ele) => {
				return ele?.id === id;
			});
			const taxStr = item?.extraData?.taxSlab;
			const tax = getTaxFromStr(taxStr);
			const beforeTax = item?.finalTransactionAmount / (1 + tax / 100);
			const taxA = item.finalTransactionAmount - beforeTax;
			return `${showRs ? '\u20B9' : ''}${taxA?.toFixed(2)}`;
		},
		'Amount Before tax': (id, showRs = true) => {
			const item = utilitiesList?.find((ele) => {
				return ele?.id === id;
			});
			const taxStr = item?.extraData?.taxSlab;
			const tax = getTaxFromStr(taxStr);
			const beforeTax = item?.finalTransactionAmount / (1 + tax / 100);
			return `${showRs ? '\u20B9' : ''}${beforeTax?.toFixed(2)}`;
		},
		'Total Amount': (id) => {
			const item = utilitiesList?.find((ele) => {
				return ele?.id === id;
			});
			return `\u20B9${item.finalTransactionAmount}`;
		},
		Status: (id) => {
			const item = utilitiesList?.find((ele) => {
				return ele?.id === id;
			});
			if (item?.transactionStatus === 'REJECTED') {
				return (
					<div className={styles.rejected}>
						<p>{item?.transactionStatus?.split('_')?.join(' ')}</p>
						<p>
							{item?.extraData?.rejectionReason
								? `Reason: (${item?.extraData?.rejectionReason})`
								: ''}
						</p>
					</div>
				);
			}
			return item?.transactionStatus?.split('_')?.join(' ');
		},
		'Payment By': (_, item) => {
			return item?.extraData?.isPaid ? 'Submitter' : 'Finance';
		},
		'Bill Date': (date) => {
			return moment(date)?.format('DD-MM-YYYY');
		},
		'Due Date': (date) => {
			return moment(date)?.format('DD-MM-YYYY');
		},
		'Created At': (date) => {
			return moment(date)?.format('DD-MM-YYYY');
		},
		'Period From': (extraData) => {
			return moment(extraData?.periodFrom)?.format('DD-MM-YYYY');
		},
		'Period To': (extraData) => {
			return moment(extraData?.periodTo)?.format('DD-MM-YYYY');
		},
		'Reference doc': (uploadedDoc) => {
			return (
				<div
					className={styles.reference}
					onClick={() => {
						if (uploadedDoc) {
							window.open(uploadedDoc, '_blank');
						} else {
							notificationServices.generateNotification({
								type: 'error',
								message: 'No Reference Uploaded',
							});
						}
					}}
				>
					<Download className={styles.icon} />
				</div>
			);
		},
		'Description': (id) => {
			const item = utilitiesList?.find((ele) => {
				return ele?.id === id;
			});
			const description = item?.extraData?.description;
			return description ?? '-';
		},
		Actions: (id) => {
			const item = utilitiesList?.find((ele) => {
				return ele?.id === id;
			});
			return (
				<div className={styles.btns}>
				{/* <Button
					variant='outlined'
					className='bg-slate-400 text-white hover:bg-slate-600 rounded-md px-3 py-1 font-medium'
					onClick={() => {
						handleEditClick(item);
					}}
					fullWidth
				>
					Edit
				</Button> */}
					{(item?.transactionStatus === 'APPROVAL_PENDING_MANAGER') &&
					levels.includes(level) ? (
						<Button
							variant='contained'
							color='primary'
							onClick={() => {
								handleApproveClick(item);
								// handleApproval('APPROVAL_PENDING_MANAGER', id);
							}}
							fullWidth
						>
							Manager Approval
						</Button>
					) : null}
					{(item?.transactionStatus === 'APPROVAL_PENDING_FINANCE') &&
					levels.includes(level) && (isInternal || Object?.values?.(userRolesDict ?? {}).includes('Finance')) ? (
						<Button
							variant='contained'
							color='primary'
							onClick={() => {
								handleApproveClick(item);
								// handleApproval('APPROVAL_PENDING_FINANCE', id);
							}}
							fullWidth
						>
							Finance Approval
						</Button>
					) : null}
					{item?.transactionStatus !== 'APPROVAL_PENDING_FINANCE' &&
					item?.transactionStatus !== 'CANCELLED' &&
					item?.transactionStatus !== 'REJECTED' ? (
						<Button
							variant='outlined'
							color='error'
							onClick={() => {
								toggleAlert(true, {
									heading: `Cancel Utility Bill - ${item?.clientTransactionId}`,
									handleConfirm: () => {
										handleStatus(item, id, 'cancelation');
										toggleAlert(false);
									},
									colorReverse: false,
									cancelText: 'No',
									confirmText: 'Yes',
									message: `Are you sure you want to Cancel Entry: ${
										item?.clientTransactionId || ''
									}?`,
									width: '28rem',
								});
							}}
							fullWidth
						>
							Cancel
						</Button>
					) : (
						'-'
					)}
				</div>
			);
		},
	};

	function handleApproveClick(item) {
		togglePOItemsModal(true, {
			heading: `Utility Bill #${item?.clientInvoiceId ?? item?.id}`,
			...item,
			isApprove: true,
			advanceBill: false,
			approvalText: 'I have checked the Utility Bill.',
			showTotal: false,
			showPdf: true,
			showPoDetails: true,
			width: '90%',
			height: '90%',
			txnHeader: {
				show: item?.extraData?.isPaid,
				heading: 'Transaction Already PAID',
				helper: 'Post Approval, a payment record will be generated',
			},
			transactionData: {
				'Client Utility ID': item?.clientTransactionId,
				'Amount Before Tax': specialItems['Amount Before tax']?.(
					item.id,
					true
				),
				'Tax Slab': specialItems['Tax slab']?.(item.id, true),
				'Tax Amount': specialItems['Tax amount']?.(item.id, true),
				'Utility Amount': `₹${item?.finalTransactionAmount}`,
				Vendor: item?.vendorName,
				Store: item?.storeName,
				'Utility Bill Date': moment(item?.transactionDate)?.format(
					'DD-MM-YYYY'
				),
				'Utility Due Date': moment(item?.dueDate)?.format('DD-MM-YYYY'),
				'Utility Period From': moment(
					item?.extraData?.periodFrom,
					'DD-MM-YYYY'
				)?.format('DD-MM-YYYY'),
				'Utility Period To': moment(
					item?.extraData?.periodTo,
					'DD-MM-YYYY'
				)?.format('DD-MM-YYYY'),
				'Utility Category': item?.category,
				'Payment Term': item?.extraData?.paymentTerm,
				'Bill Number': item?.extraData?.billNumber,
				'Description': item?.extraData?.description,
				Status: item?.transactionStatus,
			},
			hideItems: true,
			excludedColumns: ['Used For', 'Last Purchase Rate 1', 'Last Purchase Rate 2', 'Last Purchase Rate 3', 'Recommended Quantity'],
		});
	}

	const onExportClick = () => {
		const headers = TABLE_COLUMNS?.map((ele) => {
			return ele?.title;
		});
		headers.splice(5, 0, 'Rejection Reason');
		headers.splice(16, 1);
		headers.splice(16, 0, ...['IGST amount', 'CGST amount', 'SGST amount']);
		// for adding at last index
		headers.splice(999, 0, ...['store gst', 'vendor gst']);
		const totalValues = [];
		utilitiesList?.forEach((bill) => {
			if (bill?.transactionStatus !== 'CANCELLED') {
				totalValues?.push([
					bill?.id,
					bill?.vendorName,
					bill?.storeName,
					bill?.clientTransactionId ?? '-',
					bill?.transactionStatus,
					(bill?.extraData?.isPaid ? 'Submitter' : 'Finance') ?? '-',
					bill?.extraData?.rejectionReason ?? '-',
					bill?.initiatedByUserDisplayName ?? '-',
					moment(bill?.createdAt).format('YYYY-MM-DD') ?? '-',
					moment(bill?.transactionDate).format('DD-MM-YYYY') ?? '-',
					moment(bill?.dueDate).format('DD-MM-YYYY') ?? '-',
					bill?.category,
					moment(bill?.extraData?.periodFrom).format('DD-MM-YYYY') ?? '-',
					moment(bill?.extraData?.periodTo).format('DD-MM-YYYY') ?? '-',
					bill?.l1ActionUserDisplayName,
					bill?.l2ActionUserDisplayName,
					specialItems['Amount Before tax']?.(bill.id, false),
					specialItems['Tax slab']?.(bill.id),
					!bill?.extraData?.isSameState
						? specialItems['Tax amount']?.(bill.id, false)
						: 0,
					bill?.extraData?.isSameState
						? (
								Number(
									specialItems['Tax amount']?.(bill.id, false)
								) / 2
						  ).toFixed(2)
						: 0,
					bill?.extraData?.isSameState
						? (
								Number(
									specialItems['Tax amount']?.(bill.id, false)
								) / 2
						  ).toFixed(2)
						: 0,
					bill?.finalTransactionAmount,
					bill?.uploadedDoc,
					`"${bill?.extraData?.description}"`,
					storeIdMap?.[bill?.storeId]?.gstNumber ?? '-',
					vendorIdMap?.[bill?.vendorId]?.gstin ?? '-',
				]);
			}
		});
		const fileName = getFileName(filters);
		handleExcelDownload(headers, totalValues, fileName);
	};
	const fetchPettyCashList = async (req, isRefresh = false) => {
		setIsRefresh(isRefresh);
		setIsLoading(true);
		setFilters(req);
		const searchFilterPayload = {};
		searchFilters?.forEach((ele) => {
			if (ele?.value) {
				searchFilterPayload[ele?.id] = ele?.value;
			}
		});
		const filters = {
			subTypes: ['UTILITIES'],
			storeId: null,
			vendors: req?.vendors?.id,
			status: req?.status,
			// dateRangeFilter: {
			// from: moment(req?.dateRange?.from).format('YYYY-MM-DD'),
			// to: moment(req?.dateRange?.to).format('YYYY-MM-DD'),
			// },
		};
		if (req?.dateRange?.active) {
			filters.dateRangeFilter = {
				timeType: req?.timeType?.value,
				from: moment(req?.dateRange?.from).format('YYYY-MM-DD'),
				to: moment(req?.dateRange?.to).format('YYYY-MM-DD'),
			};
		}
		try {
			const response =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req: {
						data: {
							type: 'BILL',
							filters,
							...searchFilterPayload,
						},
					},
				});
			if (response?.statusCode === 200) {
				// setSelectedStore(store);
				setUtilitiesList(response?.data);
				// setLatestVersion(responseData?.data?.latestVersion);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('Error', error);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		if(search?.keyPress && search?.searchValue?.trim() === '') {
			fetchPettyCashList(filters);
		}
	}, [search?.searchValue]);

	const idSearch = async () => {
		setIsLoading(true);
		const filters = {
			...(search?.value === 'id' && {id: Number(search?.searchValue)}),
			...(search?.value === 'clientTransactionId' && {
				clientTransactionId: search?.searchValue,
			}),
		};
		try {
			const response =
				await inventoryAnalyticsServices.fetchInvTransRecord({
					req: {
						data: {
							type: 'BILL',
							search: filters,
						},
					},
				});
			if (response?.statusCode === 200) {
				// setSelectedStore(store);
				setUtilitiesList(response?.data);
				// setLatestVersion(responseData?.data?.latestVersion);
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log('Error', error);
		} finally {
			setIsLoading(false);
		}
	};

	const handleAddClick = () => {
		const redirectUrl = `${urls.EXTENSION}${urls.UTILITIES_PAGE}/add`;
		history.push(redirectUrl);
	};

	const handleViewClick = async (item) => {
		try {
			const response = await inventoryAnalyticsServices.fetchInvTransDoc({
				req: {
					params: {
						transactionId: item?.id,
					},
				},
			});
			if (response?.statusCode === 200) {
				togglePOItemsModal(true, {
					heading: `Utility Bill #${
						item?.clientInvoiceId ?? item?.id
					}`,
					...item,
					isApprove: false,
					advanceBill: false,
					approvalText: 'I have checked the Utility Bill.',
					showTotal: false,
					showPdf: true,
					showPoDetails: true,
					width: '90%',
					height: '90%',
					previewFile: response?.data?.base64,
					transactionData: {
						'Client Utility ID': item?.clientTransactionId,
						'Utility Amount': item?.finalTransactionAmount,
						Vendor: item?.vendorName,
						Store: item?.storeName,
						'Utility Bill Date': moment(
							item?.transactionDate
						)?.format('DD-MM-YYYY'),
						'Utility Due Date': moment(item?.dueDate)?.format(
							'DD-MM-YYYY'
						),
						'Utility Period From': moment(
							item?.extraData?.periodFrom,
							'M/D/YYYY'
						)?.format('DD-MM-YYYY'),
						'Utility Period To': moment(
							item?.extraData?.periodTo,
							'M/D/YYYY'
						)?.format('DD-MM-YYYY'),
						'Utility Category': item?.category,
						'Payment Term': item?.extraData?.paymentTerm,
						'Bill Number': item?.extraData?.billNumber,
						'Description': item?.extraData?.description,
						Status: item?.transactionStatus,
					},
					hideItems: true,
					excludedColumns: ['Used For', 'Last Purchase Rate 1', 'Last Purchase Rate 2', 'Last Purchase Rate 3', 'Recommended Quantity'],
				});
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
	};

	const getRowStyles = (status) => {
		return styles?.[status];
	};

	const filtersInfo = {
		header:{
				date: false,
				statusAndTypes: false,
				store: false,
		},
		dateRange: {
			text: 'Bill Date Range',
			show: true,
		},
		status: {
			text: 'Status',
			show: true,
		},
		vendor: {
			show: true,
			text: 'Vendor',
		},
		timeType: {
			text: 'Date Time Type',
			show: true,
		},
	}
	const dropDownItems = [
		{
			label: 'ID',
			value: 'id',
			placeholder: 'Search by ID',
			getData: true,
		},
		{
			label: 'Client Transaction ID',
			value: 'clientTransactionId',
			placeholder: 'Search by Client Transaction ID',
			getData: true,
		},
	];
	const handleCall = (e) => {
		if(e.key === 'Enter') {
			idSearch();
		}
	};

	const exportInfo = {
		showExportBtn : true,
	};

	return (
		<div className={styles.root}>
			<BackdropLoader isLoading={isLoading} showProgress />
			<POItemsModal
				handleConfirm={handleStatus}
				handleReject={(data, rejectionReason) => {
					handleStatus(data, rejectionReason, 'rejection');
				}}
			/>
			<ImagesFinder
				timeTypeArray={timeTypeArr}
				statusList={statusList}
				onSubmit={fetchPettyCashList}
				update={update}
				filtersInfo={filtersInfo}
				exportInfo={exportInfo}
			/>
			<div className='flex flex-col gap-2 w-full'>
			<div className='flex justify-between m-4 '>
				<span className='font-bold text-[16px]'>Utilities</span>
				{level !== 1 && (
					<Button
						onClick={handleAddClick}
						className='bg-yellow-400 hover:bg-yellow-500 rounded-md flex items-center justify-center gap-2 text-black'
					>
						+ Add Utility
					</Button>
				)}
			</div>
			<div className='flex gap-4 w-full justify-start items-center py-1'>
				<div className='w-[82%]'>
					<GlobalSearch
						dropDownOptions={dropDownItems}
						setSelectedValue={setSearch}
						handleValue={handleCall}
						isRefresh={isRefresh}
					/>
				</div>
				<Tooltip title='Refresh Utilities'>
					<RefreshCcw className='size-5 cursor-pointer' onClick={() => {
						fetchPettyCashList(filters, true);
					}} />
				</Tooltip>
				<Button
					onClick={() => {
						toggleFiltersDrawer(true, {
							exportFrontend : true,
							handleExportFrontend : onExportClick,
						});
					}}
					className='flex justify-center gap-2 px-4 py-2 text-white bg-teal-600 border border-gray-300 rounded-md hover:bg-teal-700'
				>
					<span className='text-nowrap'>Filter & Export</span>
					<Filter className='size-4' />
				</Button>
				</div>
			</div>
			{filtersInfoChip(filtersInfo, filters)}
			<div className={styles.list}>
				<ListTable
					colMap={COLMAP}
					columns={TABLE_COLUMNS}
					data={utilitiesList?.map((ele) => {
						return {
							...ele,
							rowStyles: getRowStyles(ele?.transactionStatus),
						};
					})}
					actions={getActionColumn(BASE_COLUMN, ADDITIONAL_COLUMNS, level)}
					special={specialItems}
					handleViewClick={handleViewClick}
					allowExport={false}
				/>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const { navState, userPermissions } = state.navigation;
	const stores = state?.form?.STORES?.data?.LIST;
	const { LIST: vendorsList } = state.form.ALL_VENDORS.data;
	const { userList } = state?.auth;

	return {
		stores,
		vendorsList,
		navState,
		userPermissions,
		userList,
	};
};

const mapDispatchToProps = {
	togglePOItemsModal: modalActions.togglePOItemsModal,
	toggleAlert: modalActions.toggleAlert,
	fetchAllVendors: formActions.gateway,
	fetchStoresList: formActions.gateway,
	fetchUserList: authActions?.fetchUserList,
	toggleFiltersDrawer: drawerActions.toggleFiltersDrawer,
};
export default connect(mapStateToProps, mapDispatchToProps)(UtilitiesPage);
